import http from 'http/http';
import URLS from 'http/urls';
import { appUrl } from 'http/helpers';
import qs from 'qs';
import * as constants from './constants';

import {
  TokensResponse,
  UserAuthFormData,
  AuthorizationResponse,
} from './types';
import { Secretary } from 'types/entities';

export interface ChangePasswordDTO {
  oldPassword: string;
  newPassword: string;
}

export const userApi = {
  login: async (data: UserAuthFormData) => {
    const stateLength = 64;
    const state = userApi.state(stateLength);
    const redirectUri =
      window.location.protocol + '//' + window.location.host + '/cb';

    const authorizationData = {};
    authorizationData[constants.FORM_FIELD_RESPONSE_TYPE] =
      constants.RESPNOSE_TYPE_CODE;
    authorizationData[constants.FORM_FIELD_CLIENT_ID] =
      constants.CLIENT_ID_SIONUM;
    authorizationData[constants.FORM_FIELD_STATE] = state;
    authorizationData[constants.FORM_FIELD_REDIRECT_URI] = redirectUri;

    return http
      .get(appUrl(URLS.oAuthAuthorization), {
        params: authorizationData,
        headers: {
          accept: '*/*',
        },
      })
      .then(async response => {
        if (response.headers['content-type'] === 'text/html;charset=UTF-8') {
          const html = response.data as string;
          if (
            html.indexOf('id="username"') >= 0 &&
            html.indexOf('id="password"')
          ) {
            const loginData = {};
            loginData[constants.FORM_FIELD_USERNAME] = data.username;
            loginData[constants.FORM_FIELD_PASSWORD] = data.password;

            return http
              .post(appUrl(URLS.login), qs.stringify(loginData), {
                headers: {
                  'content-type': 'application/x-www-form-urlencoded',
                },
              })
              .then(async loginResponse => {
                if (
                  loginResponse.headers['content-type'] ===
                  'text/html;charset=UTF-8'
                ) {
                  const loginHtml = loginResponse.data as string;
                  if (loginHtml.indexOf('alert-danger') >= 0) {
                    throw new Error('login failed');
                  }
                } else if (
                  loginResponse.headers['content-type'] === 'application/json'
                ) {
                  return userApi.getAccessToken(loginResponse, redirectUri);
                }
              });
          }
        } else if (response.headers['content-type'] === 'application/json') {
          return userApi.getAccessToken(response, redirectUri);
        }
      });
  },

  state: (length: number): string => {
    let result = '';
    const characters =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersNumber = characters.length;
    for (let i = 0; i < length; i += 1) {
      result += characters.charAt(Math.floor(Math.random() * charactersNumber));
    }

    return result;
  },

  refreshToken: (refreshToken: string) => {
    const tokenData = {};
    tokenData[constants.FORM_FIELD_GRANT_TYPE] =
      constants.GRANT_TYPE_REFRESH_TOKEN;
    tokenData[constants.FORM_FIELD_REFRESH_TOKEN] = refreshToken;

    return http.post<FormData, TokensResponse>(
      appUrl(URLS.authToken),
      qs.stringify(tokenData),
      {
        auth: {
          username: constants.CLIENT_ID_SIONUM,
          password: constants.CLIENT_SECRET_SIONUM,
        },
        headers: {
          'content-type': 'application/x-www-form-urlencoded',
        },
      },
    );
  },

  secretaries() {
    return http.get<Secretary>(appUrl(URLS.secretaries));
  },

  passwordRecovery(data: { email: string }) {
    return http.post(appUrl(URLS.passwordRecovery), data);
  },

  changePassword(userId: string, data: ChangePasswordDTO) {
    return http.post<ChangePasswordDTO, unknown>(
      appUrl(URLS.changePassword),
      data,
      {
        replaceParams: { id: userId },
      },
    );
  },

  getAccessToken(response, redirectUri: string) {
    const authorizationResponse = response.data as AuthorizationResponse;
    const tokenData = {};
    tokenData[constants.FORM_FIELD_GRANT_TYPE] =
      constants.GRANT_TYPE_AUTHORIZATION_CODE;
    tokenData[constants.FORM_FIELD_CODE] = authorizationResponse.code;
    tokenData[constants.FORM_FIELD_REDIRECT_URI] = redirectUri;
    tokenData[constants.FORM_FIELD_CLIENT_ID] = constants.CLIENT_ID_SIONUM;
    return http.post<any, TokensResponse>(
      appUrl(URLS.authToken),
      qs.stringify(tokenData),
      {
        auth: {
          username: constants.CLIENT_ID_SIONUM,
          password: constants.CLIENT_SECRET_SIONUM,
        },
        headers: {
          'content-type': 'application/x-www-form-urlencoded',
        },
      },
    );
  },
};
